import React, { lazy, Suspense } from "react";
import Grid from "@mui/material/Grid";
import { Helmet } from "react-helmet";
import { useLocation } from "react-router-dom";
import "../Tools.css";
import "../css/Articles.css";
import moment from "moment";

const ArticleOfBaby = lazy(() => import("../component/ArticleOfBaby"));
const ArticleOfPregnancy = lazy(() =>
  import("../component/ArticleOfPregnancy")
);
const ArticleOfOvulation = lazy(() =>
  import("../component/ArticleOfOvulation")
);
const ArticleOfPregnancyAdvices = lazy(() =>
  import("../component/ArticleOfPregnancyAdvices")
);
const ArticleOfKid = lazy(() => import("../component/ArticleOfKid"));

const LazyImage = lazy(() => import("../component/LazyImage"));

function ArticlePage(props) {
  const [item, setItem] = React.useState();
  const location = useLocation();
  const [metaDesc, setMetaDesc] = React.useState();
  const [header, setHeader] = React.useState();
  const [showPersentile, setShowPersintile] = React.useState(false);
  const [showChinese, setShowChinese] = React.useState(false);
  const [weekMonth, setWeekMonth] = React.useState(false);
  const [showMessages, setShowMessages] = React.useState(false);
  const [showBabyArticles, setShowBabyArticles] = React.useState(false);
  const [showPregnancyArticles, setShowPregnancyArticles] =
    React.useState(false);
  const [showOvulationArticles, setShowOvulationArticles] =
    React.useState(false);
  const [showAdviceArticles, setShowAdviceArticles] = React.useState(false);
  const [showKidArticles, setShowKidArticles] = React.useState(false);
  const [itemImage, setItemImage] = React.useState(null);
  const [locationPathname, setLocationPathname] = React.useState("");

  const renderLoader = () => <></>;

  React.useEffect(() => {
    try {
      window.scrollTo(0, 0);
      const pathname = location.pathname;
      setLocationPathname(pathname);
      const arr = pathname.split("/");
      let tempDesc = "";
      if (arr[1] === "makaleler") {
        const ids = arr[arr.length - 1].split("-");
        let article_array = [];
        if (arr[2] === "dogum-bebek-gelisimi-takibi") {
          setShowBabyArticles(true);
          return;
        } else if (arr[2] === "hamilelik-planlama-ovulasyon") {
          setShowOvulationArticles(true);
          return;
        } else if (arr[2] === "hafta-hamile-gebelik-takibi") {
          setShowPregnancyArticles(true);
          return;
        } else if (arr[2] === "anne-cocuk-bebek-urun-onerileri") {
          setShowAdviceArticles(true);
          return;
        } else if (arr[2] === "anne-cocuk-gelisimi-takibi") {
          setShowKidArticles(true);
          return;
        } else if (arr[2] === "anne-hamile-sohbet-topluluk-soru-cevap") {
          console.log("xxx");
          setShowMessages(true);
          return;
        }
        tempDesc =
          article_array[ids[1]].values[ids[2]].content[0].tag === "p"
            ? article_array[ids[1]].values[ids[2]].content[0].text
            : article_array[ids[1]].values[ids[2]].content[1].text;
        if (
          article_array[ids[1]].values[ids[2]].products !== undefined &&
          article_array[ids[1]].values[ids[2]].products !== null &&
          article_array[ids[1]].values[ids[2]].products.length > 0
        ) {
          article_array[ids[1]].values[ids[2]].source =
            article_array[ids[1]].values[ids[2]].products[0].image;
        }
        setItem(article_array[ids[1]].values[ids[2]]);
        setHeader(article_array[ids[1]].values[ids[2]].header);
      } else if (
        arr[1].includes("hafta-hafta-hamilelik-kontrol-listesi-takibi")
      ) {
        setHeader(
          parseInt(arr[2].split("-")[0], 10) +
            ". Hafta Hamilelik Kontrol Listesi"
        );
        setShowChinese(true);
        const {
          default_pregnancy_milestone_value,
        } = require("../tools/PregnancyChecklist");
        tempDesc =
          `${parseInt(
            arr[2].split("-")[0],
            10
          )}. Hafta Hamilelik Kontrol Listesi; ` +
          default_pregnancy_milestone_value[
            parseInt(arr[2].split("-")[0], 10) - 1
          ].values[0].checklists[0].text;
        setItem(
          default_pregnancy_milestone_value[
            parseInt(arr[2].split("-")[0], 10) - 1
          ].values
        );
      } else if (arr[1].includes("hafta-hafta-hamilelik")) {
        const weekly =
          arr[2].split("-")[0] === "hamilelikte"
            ? parseInt(arr[2].split("-")[1], 10)
            : parseInt(arr[2].split("-")[0], 10);
        setHeader("Hamilelikte - Gebelikte " + weekly + ". Hafta");
        setShowChinese(true);
        setWeekMonth(weekly);
        const { PREGNANCY_TRACKER } = require("../tools/PregnancyTracker");
        tempDesc =
          `Hamilelikte ${
            arr[2].split("-")[0] === "hamilelikte"
              ? parseInt(arr[2].split("-")[1], 10)
              : parseInt(arr[2].split("-")[0], 10)
          }. Hafta; ` +
          PREGNANCY_TRACKER[
            (arr[2].split("-")[0] === "hamilelikte"
              ? parseInt(arr[2].split("-")[1], 10)
              : parseInt(arr[2].split("-")[0], 10)) - 1
          ].values[0].value;
        setItem(
          PREGNANCY_TRACKER[
            (arr[2].split("-")[0] === "hamilelikte"
              ? parseInt(arr[2].split("-")[1], 10)
              : parseInt(arr[2].split("-")[0], 10)) - 1
          ].values
        );
      } else if (arr[1].includes("hafta-hafta-bebek-gelisimi-aktiviteleri")) {
        const { default_baby_activity_value } = require("../tools/Tracker");
        setHeader(
          parseInt(arr[2].split("-")[0], 10).toString() +
            ". hafta - " +
            default_baby_activity_value[parseInt(arr[2].split("-")[0], 10) - 1]
              .values[0].value
        );
        setShowPersintile(true);
        tempDesc =
          default_baby_activity_value[parseInt(arr[2].split("-")[0], 10) - 1]
            .values[0].value;
        setItem(
          default_baby_activity_value[parseInt(arr[2].split("-")[0], 10) - 1]
            .values
        );
      } else if (arr[1].includes("hafta-hafta-bebek-gelisimi")) {
        const el = parseInt(arr[2].split("-")[0], 10);
        const head =
          el > 52
            ? el - 52 + 12 > 49
              ? `6. Yaş`
              : el - 52 + 12 > 48
              ? `5. Yaş`
              : `${el - 52 + 12}. Ay`
            : `${el}. Hafta`;
        setHeader(head + " Bebek Gelişimi Tablosu Takibi");
        setShowPersintile(true);
        const { BABY_TRACKER } = require("../tools/BabyTracker");
        tempDesc =
          "Hafta Hafta Bebek Gelişimi Tablosu; " +
          BABY_TRACKER[parseInt(arr[2].split("-")[0], 10) - 1].values[0].value;
        setItem(BABY_TRACKER[parseInt(arr[2].split("-")[0], 10) - 1].values);
      } else if (arr[1].includes("ay-ay-hamilelikte-gebelikte")) {
        setHeader(
          "Hamilelikte ve Gebelikte Beslenme " +
            parseInt(arr[2].split("-")[0], 10) +
            ". Ay"
        );
        setShowChinese(true);
        const { PREGNANCY_NUTRITION } = require("../tools/Tracker");
        tempDesc =
          PREGNANCY_NUTRITION[parseInt(arr[2].split("-")[0], 10) - 1].values[0]
            .value;
        setItem(
          PREGNANCY_NUTRITION[parseInt(arr[2].split("-")[0], 10) - 1].values
        );
      } else if (arr[1].includes("ay-ay-bebek-beslenme")) {
        setHeader(
          parseInt(arr[2].split("-")[0], 10) + ". Ay Bebek Beslenmesi "
        );
        setShowPersintile(true);
        const { BABY_NUTRITION } = require("../tools/Tracker");
        tempDesc =
          BABY_NUTRITION[parseInt(arr[2].split("-")[0], 10) - 1].values[0]
            .value;
        setItem(BABY_NUTRITION[parseInt(arr[2].split("-")[0], 10) - 1].values);
      } else if (arr[1].includes("hamilelik-gebelik-belirtileri-semptomlar")) {
        const { PREGNANCY_SYMPTOMS } = require("../tools/Tracker");
        setHeader(
          PREGNANCY_SYMPTOMS[parseInt(arr[2].split("-")[0], 10) - 1].header
        );
        tempDesc =
          PREGNANCY_SYMPTOMS[parseInt(arr[2].split("-")[0], 10) - 1].content[0]
            .text;
        setItem(
          PREGNANCY_SYMPTOMS[parseInt(arr[2].split("-")[0], 10) - 1].content
        );
      } else if (
        arr[1].includes("ay-ay-bebek-gelisimi-takibi-kontrol-listesi")
      ) {
        const { default_baby_milestone_value } = require("../tools/Tracker");
        setHeader(
          parseInt(arr[2].split("-")[0], 10).toString() +
            ". ay - " +
            default_baby_milestone_value[parseInt(arr[2].split("-")[0], 10) - 1]
              .values[0].head
        );
        setShowPersintile(true);
        tempDesc =
          default_baby_milestone_value[parseInt(arr[2].split("-")[0], 10) - 1]
            .values[0].head;
        setItem(
          default_baby_milestone_value[parseInt(arr[2].split("-")[0], 10) - 1]
            .values
        );
      } else if (
        arr[2].includes("week-week-weekly-pregnancy-follow-up-development")
      ) {
        const weekly =
          arr[3].split("-")[0] === "pregnancy"
            ? parseInt(arr[3].split("-")[1], 10)
            : parseInt(arr[3].split("-")[0], 10);
        setHeader(weekly + ". Week Pregnancy Tracker");
        const {
          default_pregnancy_tracker_value_en,
        } = require("../tools/PregnancyTracker");
        tempDesc =
          "Pregnancy Tracker week by week; " +
          default_pregnancy_tracker_value_en[weekly - 1].values[0].value;
        setItem(default_pregnancy_tracker_value_en[weekly - 1].values);
      } else if (arr[2].includes("pregnancy-signs-symptoms")) {
        const {
          PREGNANCY_SYMPTOMS_EN,
        } = require("../tools/PregnancySymptomsEn");
        setHeader(
          PREGNANCY_SYMPTOMS_EN[parseInt(arr[3].split("-")[0], 10) - 1].header
        );
        tempDesc =
          PREGNANCY_SYMPTOMS_EN[parseInt(arr[3].split("-")[0], 10) - 1]
            .content[0].text;
        setItem(
          PREGNANCY_SYMPTOMS_EN[parseInt(arr[3].split("-")[0], 10) - 1].content
        );
      } else if (arr[2].includes("month-pregnancy-nutrition-health")) {
        setHeader(
          "Nutrition Month by Month during Pregnancy " +
            parseInt(arr[3].split("-")[0], 10) +
            ". Month"
        );
        const PREGNANCY_NUTRITION_EN =
          require("../tools/PregnancyNutritionEn.json").array;
        tempDesc =
          PREGNANCY_NUTRITION_EN[parseInt(arr[3].split("-")[0], 10) - 1]
            .values[0].value;
        setItem(
          PREGNANCY_NUTRITION_EN[parseInt(arr[3].split("-")[0], 10) - 1].values
        );
      } else if (arr[2].includes("week-week-baby-development-tracking")) {
        const el = parseInt(arr[3].split("-")[0], 10);
        const head =
          el > 52
            ? el - 52 + 12 > 49
              ? `6. Age`
              : el - 52 + 12 > 48
              ? `5. Age`
              : `Month`
            : `Week`;
        setHeader(head + " Baby Development Monitoring - Expectant Mothers");
        const {
          default_baby_tracker_value_en,
        } = require("../tools/BabyTracker");
        tempDesc =
          "Week by Week Baby Development; " +
          default_baby_tracker_value_en[parseInt(arr[3].split("-")[0], 10) - 1]
            .values[0].value;
        setItem(
          default_baby_tracker_value_en[parseInt(arr[3].split("-")[0], 10) - 1]
            .values
        );
      } else if (arr[2].includes("month-month-baby-nutrition")) {
        setHeader(
          "Baby Feeding Month by Month " +
            parseInt(arr[3].split("-")[0], 10) +
            ". Month"
        );
        const BabyNutritionEn = require("../tools/BabyNutritionEn.json").array;
        tempDesc =
          BabyNutritionEn[parseInt(arr[3].split("-")[0], 10) - 1].values[0]
            .value;
        setItem(BabyNutritionEn[parseInt(arr[3].split("-")[0], 10) - 1].values);
      } else if (arr[2].includes("week-week-pregnancy-checklist-tracking")) {
        setHeader(
          parseInt(arr[3].split("-")[0], 10) +
            ". Pregnancy Checklist Week by Week"
        );
        const {
          default_pregnancy_milestone_value_en,
        } = require("../tools/PregnancyChecklistEn");
        tempDesc =
          "Pregnancy Checklist Week by Week; " +
          default_pregnancy_milestone_value_en[
            parseInt(arr[3].split("-")[0], 10) - 1
          ].values[0].value;
        setItem(
          default_pregnancy_milestone_value_en[
            parseInt(arr[3].split("-")[0], 10) - 1
          ].values
        );
      }
      if (tempDesc !== null && tempDesc !== "") {
        if (tempDesc.length > 158) {
          tempDesc = tempDesc.substring(0, 155) + "...";
        }
        setMetaDesc(tempDesc);
      }
    } catch (error) {
      console.log("error", error);
    }
  }, []);

  function getArticleChildItem(data) {
    return data.map((element, index) => {
      if (element.tag === "h1") {
        return <h1 className="article-head1">{element.value}</h1>;
      } else if (element.tag === "h2") {
        return <h2 className="article-head1">{element.value}</h2>;
      } else if (element.tag === "li") {
        return (
          <ol key={index}>
            <li className="article-p">{element.value}</li>
          </ol>
        );
      } else if (element.tag === "image") {
        return (
          <img
            loading="lazy"
            className="lazyload"
            alt={element.source}
            data-src={element.source.replace(
              "awsUrlImage",
              "https://amplify-amplify5fdda0668dad4-staging-120746-deployment.s3.eu-central-1.amazonaws.com/momercy/images/"
            )}
            style={{ width: 300, height: 300, objectFit: "contain" }}
          />
        );
      } else if (element.value.includes("trimester")) {
        const ass = element.value.split("trimester");
        return (
          <div style={{ display: "flex", flexDirection: "row" }}>
            <p className="article-p">
              {ass[0]}
              <a
                className="article-p"
                target="_blank"
                style={{ textDecoration: "underline" }}
                href="https://www.momercy.com/due-date-calculator-tahmini-dogum-tarihi-hesaplama"
              >
                {" "}
                trimester
              </a>
              {ass.map((item, index) =>
                index !== 0 ? (index > 1 ? "trimester" + item : item) : ""
              )}
            </p>
          </div>
        );
      } else if (element.value.includes("hamilelik semptomları")) {
        const ass = element.value.split("hamilelik semptomları");
        return (
          <div style={{ display: "flex", flexDirection: "row" }}>
            <p className="article-p">
              {ass[0]}
              <a
                className="article-p"
                target="_blank"
                style={{ textDecoration: "underline" }}
                href="https://www.momercy.com/hamilelik-gebelik-belirtileri-semptomlar"
              >
                {" "}
                hamilelik semptomları
              </a>
              {ass.map((item, index) =>
                index !== 0
                  ? index > 1
                    ? "hamilelik semptomları" + item
                    : item
                  : ""
              )}
            </p>
          </div>
        );
      } else if (element.value.includes("gebelik semptomları")) {
        const ass = element.value.split("gebelik semptomları");
        return (
          <div style={{ display: "flex", flexDirection: "row" }}>
            <p className="article-p">
              {ass[0]}
              <a
                className="article-p"
                target="_blank"
                style={{ textDecoration: "underline" }}
                href="https://www.momercy.com/hamilelik-gebelik-belirtileri-semptomlar"
              >
                {" "}
                gebelik semptomları
              </a>
              {ass.map((item, index) =>
                index !== 0
                  ? index > 1
                    ? "gebelik semptomları" + item
                    : item
                  : ""
              )}
            </p>
          </div>
        );
      }
      return <p className="article-p">{element.value}</p>;
    });
  }

  function getChecklist(element) {
    return element.checklists.map((ch, inc) => {
      return (
        <li className="article-p" style={{ width: "100%" }}>
          {ch.text ? ch.text : ch.value}
        </li>
      );
    });
  }

  const changeTextToLink = (text, splt, link) => {
    if (text.includes(splt)) {
      const ass = text.split(splt);
      return (
        <div style={{ display: "flex", flexDirection: "row" }}>
          <h2 className="article-head1" style={{ width: "100%" }}>
            {ass[0]}
            <a
              className="article-head1"
              target="_blank"
              style={{ textDecoration: "underline" }}
              href={`https://www.momercy.com/${link}`}
            >
              {" "}
              {splt}
            </a>
          </h2>
        </div>
      );
    }
    return (
      <h2 className="article-head1" style={{ width: "100%" }}>
        {text}
      </h2>
    );
  };

  function getArticleItem() {
    let data = item;
    let products = [];
    if (item && item.content) {
      data = item.content;
    }
    if (item && item.products) {
      products = item.products;
    }

    if (data) {
      return data.map((element, index) => {
        if (element.message) {
          return (
            <Grid
              container
              justifyContent="center"
              className="shadow-box"
              style={{ padding: 10 }}
            >
              <Grid item xs={3}>
                <p className="article-head4">{element.name}</p>
                <p className="article-p1">
                  {moment.unix(element.date / 1000).format("DD-MM-YYYY hh:mm")}
                </p>
              </Grid>
              <Grid item xs={9}>
                <p className="article-p" style={{ width: "100%" }}>
                  {element.message}
                </p>
              </Grid>
            </Grid>
          );
        } else if (
          !element.checklists &&
          !element.subject1 &&
          !element.subject2
        ) {
          if (element.tag === "h1") {
            return (
              <h1 className="article-head1" style={{ width: "100%" }}>
                {element.text ? element.text : element.value}
              </h1>
            );
          } else if (element.tag === "h2") {
            return (
              <>
                {changeTextToLink(
                  element.text ? element.text : element.value,
                  " - Beslenme",
                  "hamilelikte-gebelikte-beslenme-saglik"
                )}
                {element.image && (
                  <img
                    loading="lazy"
                    alt={element.text}
                    className="lazyload"
                    data-src={element.image.replace(
                      "awsUrlImage",
                      "https://amplify-amplify5fdda0668dad4-staging-120746-deployment.s3.eu-central-1.amazonaws.com/momercy/images/"
                    )}
                    style={{ width: 300, height: 300, objectFit: "contain" }}
                  />
                )}
                {element.values && getArticleChildItem(element.values)}
              </>
            );
          } else if (element.tag.includes("h4-")) {
            const inn = parseInt(element.tag.split("h4-")[1], 10);
            return (
              <>
                <h2 className="article-head1" style={{ marginTop: 20 }}>
                  {element.text}
                </h2>
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <img
                    loading="lazy"
                    className="lazyload"
                    alt={element.text}
                    data-src={products[inn].image.replace(
                      "awsUrlImage",
                      "https://amplify-amplify5fdda0668dad4-staging-120746-deployment.s3.eu-central-1.amazonaws.com/momercy/images/"
                    )}
                    style={{ width: 300, height: 300, objectFit: "contain" }}
                  />
                </div>
              </>
            );
          } else if (element.tag === "li") {
            return (
              <li className="article-p" style={{ width: "100%" }}>
                {element.text ? element.text : element.value}
              </li>
            );
          }
        } else if (element.checklists) {
          if (element.head) {
            return (
              <>
                <h1 className="article-head1" style={{ width: "100%" }}>
                  {element.head}
                </h1>
                {getChecklist(element)}
              </>
            );
          } else getChecklist(element);
        } else if (element.subject1) {
          return (
            <>
              <h2 className="article-head1" style={{ marginTop: 20 }}>
                NE ZAMAN ENDİŞELENMELİ?
              </h2>
              {element.subject1.map((ch, inc) => {
                return (
                  <p className="article-p" style={{ width: "100%" }}>
                    {ch.p}
                  </p>
                );
              })}
            </>
          );
        } else if (element.subject2) {
          return (
            <>
              <h2 className="article-head1" style={{ marginTop: 20 }}>
                EBEVEYNİN ROLÜ
              </h2>
              {element.subject2.map((ch, inc) => {
                return (
                  <p className="article-p" style={{ width: "100%" }}>
                    {ch.p}
                  </p>
                );
              })}
            </>
          );
        }
        return (
          <p className="article-p" style={{ width: "100%" }}>
            {element.text ? element.text : element.value}
          </p>
        );
      });
    }
    return <div />;
  }

  const { loc, isNormalScreen, isMobile } = props;
  return (
    <div className={"mainRoot"}>
      <Helmet>
        {metaDesc && (
          <meta
            name="description"
            content={metaDesc}
            data-react-helmet="true"
          />
        )}
        {header && <title>{header}</title>}
        <meta
          property="og:site_name"
          content={
            loc === "en"
              ? "Pregnancy Tracking and Baby Development"
              : "Hamilelik Takibi ve Bebek Gelişimi"
          }
        />
        <meta
          property="og:url"
          content={`https://www.momercy.com/${location.pathname}`}
        />
        <meta property="og:locale" content={loc === "en" ? "en_EN" : "tr_TR"} />
        <meta
          property="og:title"
          content={
            loc === "en"
              ? "Pregnancy Tracking and Baby Development"
              : "Hamilelik Takibi ve Bebek Gelişimi"
          }
        />
        <meta
          property="og:description"
          content={
            loc === "en"
              ? "Pregnancy and pregnancy follow-up, nutrition during pregnancy, baby girl names, ovulation menstrual calendar, baby development application for mothers."
              : "Hamilelik ve gebelik sürecinde takip, hamilelikte beslenme, kız erkek bebek isimleri, yumurtlama regl takvimi, anneler için bebek gelişimi uygulaması."
          }
        />
        <meta
          name="twitter:title"
          content={
            loc === "en"
              ? "Pregnancy Tracking and Baby Development"
              : "Hamilelik Takibi ve Bebek Gelişimi"
          }
        />
        <meta
          name="twitter:description"
          content={
            loc === "en"
              ? "Pregnancy and pregnancy follow-up, nutrition during pregnancy, baby girl names, ovulation menstrual calendar, baby development application for mothers."
              : "Hamilelik ve gebelik sürecinde takip, hamilelikte beslenme, kız erkek bebek isimleri, yumurtlama regl takvimi, anneler için bebek gelişimi uygulaması."
          }
        />
        <link
          rel="canonical"
          href={`https://www.momercy.com${location.pathname}`}
        />
      </Helmet>
      <Grid
        display="flex"
        container
        alignItems="center"
        justifyContent="center"
        style={{ padding: 10 }}
      >
        <Grid
          item
          xs={isMobile ? 12 : isNormalScreen ? 8 : 7}
          style={{ marginTop: isMobile ? 10 : 30 }}
        >
          <h1 className="article-head padding-bottom-40">{header}</h1>
          {itemImage && (
            <LazyImage
              head={header}
              image={itemImage}
              className="Article-Head_Image"
              isMobile={props.isMobile}
            />
          )}
          {/*<div
            style={{
              borderRadius: 5,
              height: isMobile ? 500 : 300,
              width: "100%",
              display: "flex",
              backgroundColor: "#ffffff",
            }}
          >
            <div
              className="gradient-background"
              style={{
                width: 5,
                height: isMobile ? 500 : 300,
                marginRight: 10,
              }}
            />
            <Grid
              display="flex"
              container
              alignItems="center"
              justifyContent="center"
              style={{ padding: 20 }}
            >
              <Grid item xs={12}>
                <h2 className="general-p" style={{ textAlign: "left" }}>
                  {item[1].value}
                </h2>
              </Grid>
            </Grid>
          </div>*/}
        </Grid>

        <Grid item xs={isMobile ? 12 : isNormalScreen ? 8 : 7}>
          <article>
            {/*showMessages && (
                    <Suspense fallback={renderLoader()}>
                      <ArticleOfMessages
                        itemImage={setItemImage}
                        pathname={locationPathname}
                        header={setHeader}
                        tempDesc={setMetaDesc}
                      />
                    </Suspense>
                  )*/}
            {showBabyArticles && (
              <Suspense fallback={renderLoader()}>
                <ArticleOfBaby
                  itemImage={setItemImage}
                  pathname={locationPathname}
                  header={setHeader}
                  tempDesc={setMetaDesc}
                />
              </Suspense>
            )}
            {showPregnancyArticles && (
              <Suspense fallback={renderLoader()}>
                <ArticleOfPregnancy
                  itemImage={setItemImage}
                  pathname={locationPathname}
                  header={setHeader}
                  tempDesc={setMetaDesc}
                />
              </Suspense>
            )}
            {showOvulationArticles && (
              <Suspense fallback={renderLoader()}>
                <ArticleOfOvulation
                  itemImage={setItemImage}
                  pathname={locationPathname}
                  header={setHeader}
                  tempDesc={setMetaDesc}
                />
              </Suspense>
            )}
            {showAdviceArticles && (
              <Suspense fallback={renderLoader()}>
                <ArticleOfPregnancyAdvices
                  itemImage={setItemImage}
                  pathname={locationPathname}
                  header={setHeader}
                  tempDesc={setMetaDesc}
                />
              </Suspense>
            )}
            {showKidArticles && (
              <Suspense fallback={renderLoader()}>
                <ArticleOfKid
                  itemImage={setItemImage}
                  pathname={locationPathname}
                  header={setHeader}
                  tempDesc={setMetaDesc}
                />
              </Suspense>
            )}
            {!showKidArticles &&
              !showAdviceArticles &&
              !showBabyArticles &&
              !showBabyArticles &&
              !showPregnancyArticles &&
              !showMessages &&
              getArticleItem()}
            {showPersentile && (
              <a
                href="https://www.momercy.com/kilo-boy-bas-cevresi-persintile-hesaplama"
                target="_blank"
              >
                Persentil Hesaplama Tablosu
              </a>
            )}
            {showChinese && (
              <div style={{ display: "flex", flexDirection: "column" }}>
                <a
                  href="https://www.momercy.com/cin-cinsiyet-tahmini-hesaplama"
                  target="_blank"
                >
                  Çin Takvimi Cinsiyet Hesaplama
                </a>
                {weekMonth && (
                  <a
                    href="https://www.momercy.com/kac-aylik-hamileyim-hesaplama"
                    target="_blank"
                  >
                    {weekMonth} haftalık gebelik kaç aylık?
                  </a>
                )}
              </div>
            )}
          </article>
        </Grid>
      </Grid>
    </div>
  );
}

export default ArticlePage;
